import React from 'react'
import SelectionItemContainer from './SelectionItemContainer'
import Page from '../Page/Page'
import PageContent from '../Page/PageContent'
import TitleToolbar from '../Page/TitleToolbar'
import ToolbarButton from '../Page/ToolbarButton'
import PaginationContainer from './PaginationContainer'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import CancelIcon from '@material-ui/icons/Cancel'
import GetAppIcon from '@material-ui/icons/GetApp'
import { useMatomo } from '@datapunt/matomo-tracker-react'

export default ({ selectedStompunkter, onClear, onExport }) => {
	const selectionEmpty = selectedStompunkter.length === 0
	const { trackEvent } = useMatomo()
	return (
		<Page>
			<TitleToolbar title="Urval">
				<PaginationContainer />
				<ToolbarButton
					title = "Rensa urval"
					icon =  {<CancelIcon />}
					onClick = {onClear}
					disabled = {selectionEmpty}
				/>
				<ToolbarButton
					title = "Exportera urval"
					icon = {<GetAppIcon />}
					onClick = {() => {trackEvent({ category: 'Urval Meny', action: 'Exportera urval',name: 'onClick' });onExport()}}
					disabled = {selectionEmpty}
				/>
			</TitleToolbar>
	    	{ selectionEmpty ? nothingSelected() : selectionList(selectedStompunkter) }
	   </Page>
	)
}

const nothingSelected = () => (
	<PageContent padding>
		<Typography variant="body1">Du har inte valt några stompunkter.</Typography>
	</PageContent>
)

const selectionList = (selectedStompunkter) => (
	<PageContent>
		<List>
			{selectedStompunkter.map((id) => (
				<SelectionItemContainer id={id} key={id} />
			))}
		</List>
	</PageContent>
)


// WEBPACK FOOTER //
// ./src/components/Selection/SelectionPage.js